import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
import { ProjectCommentRequest } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';
import { getComments } from 'cd-eft/components/Projects/Project/ProjectVM'

const libraryStore = stores.AppStore.projectsLibraryStore;
const projectClassId = 4;  //Analysis project
export class AnalysisCommentsVM {
    @observable props;
    @observable projectId: string;
    @observable checkedState: any = []
    @observable readOnlyFormActive: boolean = true;
    @observable addFormActive: boolean = false;
    @observable editFormActive: boolean = false;
    @observable deleteFormActive: boolean = false;
    @observable cancelFormBtnActive: boolean = false;
    @observable editCheckboxes: boolean = false;
    @observable deleteFormBtnActive: boolean = false
    @observable deleteCheckboxes: boolean = false;
    @observable deletePopup: boolean = false;
    @observable isSaving: boolean = false;

    constructor(props) {
        this.props = props;
        this.projectId = this.props.projectId;
    }

    elementActions = {
        Edit: { action: this.toggleEditFormOn },
        Delete: { action: this.toggleDeleteFormOn },
        Add: { action: this.toggleAddFormOn },
    };

    @observable createDesignCommentForm: ICreateCommentForm = {
        projectUuid: '',
        commentTypeId: 2,
        workflowstep: '',
        commentAuthor: String(localStorage['username']),
        projectComment: '',
        editStatus: 'add'
    };

    @observable editCommentForm: ICommentForm = {
        projectUuid: '',
        commentTypeId: 2,
        projectCommentId: 0,
        workflowstep: '',
        commentAuthor: String(localStorage['username']),
        projectComment: '',
        editStatus: 'update'
    };

    // Form Validation model
    @observable formValidation = {
        formErrors: {
            projectUuid: '',
            commentTypeId: '',
            commentAuthor: '',
            workflowstep: '',
            projectComment: '',
            editStatus: ''
        },
        projectUuid: false,
        commentTypeId: false,
        commentAuthor: false,
        workflowstep: false,
        projectComment: false,
        editStatus: false,
        formValid: false,
    };

    @action.bound toggleReadOnlyFormOn() {
        this.readOnlyFormActive = !this.readOnlyFormActive
    }

    @action.bound toggleAddFormOn() {
        this.addFormActive = !this.addFormActive;
        this.cancelFormBtnActive = false;
        this.editFormActive = false;
        this.deleteFormActive = false;
        this.readOnlyFormActive = true;
        this.clearErrors()
    }

    @action.bound toggleEditFormOn() {
        this.editFormActive = !this.editFormActive
        this.cancelFormBtnActive = true;
        this.addFormActive = false
        this.deleteFormActive = false;
        this.resetEditCommentForm();
        this.toggleReadOnlyFormOn()
        this.clearErrors()
    }

    @action.bound toggleDeleteFormOn() {
        this.deleteFormActive = !this.deleteFormActive
        this.cancelFormBtnActive = false;
        this.addFormActive = false
        this.editFormActive = false;
        this.readOnlyFormActive = true;
        this.checkedState = new Array(libraryStore.analysisComments.length).fill(false)
    }

    @action.bound toggleDeletePopup() {
        this.deletePopup = true;
    }

    @action.bound resetComments() {
        this.clearErrors()
        this.addFormActive = false
        this.readOnlyFormActive = true;
        this.editFormActive = false;
        this.cancelFormBtnActive = false
        this.deleteFormActive = false;
        this.deletePopup = false;
        this.resetCreateCommentForm()
        this.resetEditCommentForm();
    }

    @action.bound resetCreateCommentForm() {
        this.createDesignCommentForm = {
            projectUuid: '',
            commentTypeId: 2,
            workflowstep: '',
            commentAuthor: String(localStorage['username']),
            projectComment: '',
            editStatus: 'add'
        }
    }

    @action.bound resetEditCommentForm() {
        this.editCommentForm = {
            projectUuid: '',
            commentTypeId: 2,
            projectCommentId: 0,
            workflowstep: '',
            commentAuthor: String(localStorage['username']),
            projectComment: '',
            editStatus: 'update'
        };
        this.checkedState = new Array(libraryStore.analysisComments.length).fill(false)
    }

    @action.bound cancelComment() {
        this.resetComments()
    }

    @action.bound cancelEditComment(position) {
        this.resetEditCommentForm();
        this.cancelFormBtnActive = true;
    }


    // form validation by field
    @action.bound validateField(fieldName, value) {
        if (value === undefined) {
            return;
        }
        // connects form field to validation table
        const keyValid = fieldName + 'Valid';
        let fieldValid = this.formValidation[keyValid];
        const fieldValidationErrors = this.formValidation.formErrors;
        switch (fieldName) {
            case 'projectUuid':
                // is required value 
                fieldValid = value !== ''
                fieldValidationErrors[fieldName] = fieldValid
                    ? ''
                    : 'projectUuid is required';
                break;
            case 'commentTypeId':
                // is required and value should not be 0
                fieldValid = value !== '' && value !== 0;
                fieldValidationErrors[fieldName] = fieldValid
                    ? ''
                    : 'commentTypeId is required';
                break;
            case 'commentAuthor':
                // is required value
                fieldValid = value !== '';
                fieldValidationErrors[fieldName] = fieldValid
                    ? ''
                    : 'commentAuthor is required';
                break;
            case 'editStatus':
                // is required value
                fieldValid = value !== '';
                fieldValidationErrors[fieldName] = fieldValid
                    ? ''
                    : 'editStatus is required';
                break;
            case 'workflowstep':
                // is required and value 
                fieldValid = value !== ''
                fieldValidationErrors[fieldName] = fieldValid
                    ? ''
                    : 'Workflowstep is required';
                break;
            case 'projectComment':
                // is required and value should not be null
                fieldValid = value !== '' && value !== null;
                fieldValidationErrors[fieldName] = fieldValid ? '' : 'Design comment is required';
                break;
            default:
                break;
        }
        this.formValidation.formErrors = fieldValidationErrors;
        this.formValidation[keyValid] = fieldValid;
        this.validateForm();
    }

    // checks if there are any error msgs over entire form
    @action.bound validateForm() {
        let valid = true;
        for (const key in this.formValidation.formErrors) {
            if (!this.formValidation[key + 'Valid']) {
                valid = false;
            }
        }
        this.formValidation.formValid = valid;
    }

    @action.bound errorClass(field) {
        const errorMessage = this.formValidation.formErrors[field];
        return errorMessage.length === 0 ? '' : ' usa-input--error';
    }

    @action.bound clearErrors() {
        this.formValidation = {
            formErrors: {
                projectUuid: '',
                commentTypeId: '',
                commentAuthor: '',
                workflowstep: '',
                projectComment: '',
                editStatus: ''
            },
            projectUuid: false,
            commentTypeId: false,
            commentAuthor: false,
            workflowstep: false,
            projectComment: false,
            editStatus: false,
            formValid: false,
        }
    }
    @action.bound handleSubmit = e => {
        e.preventDefault();
    }


    @action.bound handleInput(event) {
        event.preventDefault();
        const { name, value } = event.target;
        this.createDesignCommentForm[name] = value
        this.validateField(name, value);
    }

    @action.bound handleInputChange(event, position) {
        event.preventDefault();
        const { name, value } = event.target;
        this.editCommentForm[name] = value
        this.validateField(name, value);
    }

    @action.bound handleCheckBox(position) {
        this.cancelFormBtnActive = false
        this.checkedState = this.checkedState.map((item, index) =>
            index === position ? !item : item
        );

        this.editCommentForm.projectUuid = libraryStore.analysisComments[position].projectUuid
        this.editCommentForm.projectCommentId = libraryStore.analysisComments[position].projectCommentId
        this.editCommentForm.commentTypeId = libraryStore.analysisComments[position].commentTypeId
        this.editCommentForm.workflowstep = libraryStore.analysisComments[position].workflowStep
        this.editCommentForm.projectComment = libraryStore.analysisComments[position].projectComment
    }

    @action.bound handleDeleteCheckBox(position) {
        this.checkedState = this.checkedState.map((item, index) =>
            index === position ? !item : item
        );
    }

    @action.bound async createComment() {
        this.createDesignCommentForm.projectUuid = this.projectId
        this.isSaving = true;

        if (!this.formValidation.formValid) {
            for (const field in this.createDesignCommentForm) {
                const value = this.createDesignCommentForm[field];
                this.validateField(field, value);
            }
            // If invalid - return and halt execution
            if (!this.formValidation.formValid) {
                this.isSaving = false;
                return;
            }
        }

        const analysisPostJSON: ProjectCommentRequest = {
            projectUuid: this.projectId,
            commentTypeId: this.createDesignCommentForm.commentTypeId,
            workflowStep: this.createDesignCommentForm.workflowstep,
            commentAuthor: this.createDesignCommentForm.commentAuthor,
            projectComment: this.createDesignCommentForm.projectComment,
            editStatus: this.createDesignCommentForm.editStatus
        };

        MessageCenter.clearMessages();
        try {
            const response = await PRJAPI.ProjectCommentController.createProjectCommentByProjectUuidUsingPOST(analysisPostJSON)
            if (response.data) {
                await getComments(this.createDesignCommentForm.projectUuid, projectClassId)
            }
            this.resetComments();
            this.props.updateCallback();
        } catch (error) {
            MessageCenter.addError((error as Error).message);
        } finally {
            this.isSaving = false;
        }
    }

    @action.bound async saveEditComment() {
        if (!this.formValidation.formValid) {
            for (const field in this.editCommentForm) {
                const value = this.editCommentForm[field];
                this.validateField(field, value);
            }
            // If invalid - return and halt execution
            if (!this.formValidation.formValid) {
                return;
            }
        }
        const postJSON = {
            projectUuid: this.editCommentForm.projectUuid,
            commentTypeId: this.editCommentForm.commentTypeId,
            projectCommentId: this.editCommentForm.projectCommentId,
            workflowStep: this.editCommentForm.workflowstep,
            commentAuthor: this.editCommentForm.commentAuthor,
            projectComment: this.editCommentForm.projectComment,
            editStatus: this.editCommentForm.editStatus
        };

        try {
            await PRJAPI.ProjectCommentController.editProjectCommentByProjectCommentIdUsingPOST(postJSON)
            await getComments(this.editCommentForm.projectUuid, projectClassId)
            this.resetComments()
            this.props.updateCallback();
        } catch (error) {
            MessageCenter.addError((error as Error).message);
        }
    }


    @action.bound async handleDeleteComments() {
        const postJSON = {
            projectCommentIdList: libraryStore.analysisComments.filter((comment, index) => this.checkedState[index]).map(data => data.projectCommentId),
            projectUuid: this.projectId
        };
        try {
            await PRJAPI.ProjectCommentController.deleteProjectCommentsByProjectCommentIdsUsingPOST(postJSON)
            await getComments(this.projectId, projectClassId)
            this.resetComments()
            this.props.updateCallback();
        } catch (error) {
            MessageCenter.addError((error as Error).message);
        }
    }
}
interface ICreateCommentForm {
    projectUuid: string;
    commentTypeId: number;
    workflowstep: string;
    commentAuthor: string;
    projectComment: string;
    editStatus: string;
}

interface ICommentForm {
    projectUuid: string;
    projectCommentId: number
    commentTypeId: number;
    workflowstep: string;
    commentAuthor: string;
    projectComment: string;
    editStatus: string;
}